import { locationService } from '@/services/api/location.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { locationModel } from '@/models/api/location.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const LOCATION_MODULE = "api/location";

// ACTIONS
export const GET_ALL_LOCATION = 'getAllLocation';
export const CREATE_LOCATION = 'createLocation';
export const GET_LOCATION = 'getLocation';
export const UPDATE_LOCATION = 'updateLocation';
export const UPDATE_LOCATION_STATUS = 'updateLocationStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_LOCATION_SUCCESS = "allLocationSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_LOCATION_SUCCESS = "getLocationSuccess";

export const actions = {
    [GET_ALL_LOCATION]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        locationService
            .getAll(filter)
            .then((result) => {
                commit(ALL_LOCATION_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_LOCATION]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return locationService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_LOCATION, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_LOCATION]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return locationService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_LOCATION_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_LOCATION]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return locationService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_LOCATION, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_LOCATION_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return locationService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_LOCATION, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_LOCATION_SUCCESS](state, {data}) {
        let location = data.data || [];
        state.list.data = location;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = location.map(item => locationModel(item));
        }
    },
    [GET_LOCATION_SUCCESS](state, data) {
        state.details = locationModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
